<template>
  <div class="question_test">
    <h2 class="title_com">培训问卷</h2>
    <section class="pd2430">
      <!-- 搜索 -->
      <MySearch
        :list2="selecteArr2"
        :list3="selecteArr3"
        :showSelect1="0"
        :is_reset="1"
        ref="childSearch"
        :triggerPhName="1"
        @resetRadioVal="resetRadioVal"
        @changeVal="changeVal"
        @resetPage="resetPage"
        @requestCommonFn="requestCommonFn"
      ></MySearch>
      <!-- 筛选 -->
      <MyRadioGroup
        @changeRadioVal="changeRadioVal"
        :list="radioArr"
        ref="childRadio"
        :is_show="2"
      ></MyRadioGroup>
      <!-- 表格 -->
      <QuestionTB :list="questionListArr"> </QuestionTB>
      <!-- 分页 -->
      <Pagination
        :currentPage="currentPage"
        :pageSize="pageSize"
        :total="total"
        :selectSize="[10, 20, 30, 40]"
        @changePage="changePage"
        @changeSize="changeSize"
        v-if="questionListArr.length !== 0"
      ></Pagination>
    </section>
  </div>
</template>

<script>
import { QuestionListApi } from "@/api/student";
export default {
  data() {
    return {
      // 是否考核
      selecteArr2: [
        {
          name: "全部",
          id: 2,
        },
        {
          name: "否",
          id: 0,
        },
        {
          name: "是",
          id: 1,
        },
      ],
      // 是否完成
      selecteArr3: [
        {
          name: "全部",
          id: 1,
        },
        {
          name: "未完成",
          id: 0,
        },
        {
          name: "已完成",
          id: 2,
        },
      ],
      // 1投票 2评价 3研修日志 4普通问卷(问卷)
      radioArr: [
        {
          name: "全部",
          status: 0,
        },
        {
          name: "投票",
          status: 1,
        },
        {
          name: "评价",
          status: 2,
        },
        {
          name: "研修日志",
          status: 3,
        },
        {
          name: "普通问卷",
          status: 4,
        },
      ],
      currentPage: 1, //当前页数
      pageSize: 10, // 当前页条数
      total: 11, // 总数
      is_check: "", // 考核 1是 0否
      title: "", // 标题
      submit: "", // 	0 未完成、2已完成
      questionType: "", // 问卷类型：1投票 2评价 3研修日志 4普通问卷(问卷)
      questionListArr: [], // 问卷列表
    };
  },
  methods: {
       // 重置页数
    resetPage() {
        this.currentPage = 1;
    },

    // 重置表单
    resetForm() {
      this.title = "";
      this.submit = "";
      this.is_check = "";
      this.$refs.childSearch.resetIptVal();
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 修改radioVal
    changeRadioVal(val) {
      this.resetForm();
      this.questionType = val;
      this.requestCommonFn();
    },
    // 重置RadioVal
    resetRadioVal() {
      this.questionType = "";
      this.$refs.childRadio.radioVal = 0;
    },
    // 修改查询的值
    changeVal(val) {
      this.is_check = val.assess;
      this.title = val.workName;
      this.submit = val.finish;
      if (val.assess == 2) {
        this.is_check = "";
      } else {
        this.is_check = val.assess;
      }
      if (val.finish == 1) {
        this.submit = "";
      } else {
        this.submit = val.finish;
      }
    },
    // 问卷列表
    requestCommonFn() {
      QuestionListApi({
        limit: this.pageSize,
        page: this.currentPage,
        user_id: this.userInfo.id,
        type: this.questionType,
        class_id: this.class_id,
        is_check: this.is_check,
        title: this.title,
        submit: this.submit,
      }).then((res) => {
        this.questionListArr = res.data.data;
        this.total = res.data.total;
      });
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      this.requestCommonFn();
    },
  },
  created() {
    this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.question_test {
  background-color: #fff;
  section {
  }
}
</style>